<template>
  <div class="outer">
    <div class="inner img">
      <img :src="image" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PictureFrame",
  props: {
    image: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.outer {
  width: 100%;
  height: 100%;
  padding: 15px;
  border-radius: 3px;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url(/img/sand_texture.png);
  box-shadow: -5px -5px 3px white, 5px 5px 3px #00000042;

  .inner {
    width: 100%;
    height: 100%;
    min-height: 310px;
    border-radius: 5px;
    box-shadow: 5px 5px 5px white, -5px -5px 5px #00000048;

    img {
      // min-height: 310px;
      border-radius: inherit;
      object-position: center;
    }
  }
}
</style>

<style lang="scss">
$light: #ffffff29;
$dark: #000000a5;
$blur: 6px;
.theme-dark {
  .outer {
    box-shadow: -5px -5px $blur $light, 5px 5px $blur $dark;
    
    .inner {
      box-shadow: 5px 5px $blur $light, -5px -5px $blur $dark;
    }
  }
}
</style>
